var _circle, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArbitrum(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 11,
    r: 10,
    fill: "url(#paint0_linear_3452_13448)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3452_13448)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.85659 6.18042H7.5744C7.48585 6.18042 7.40682 6.23579 7.37644 6.31895L4.00622 15.5581C3.98116 15.6268 4.03205 15.6996 4.1052 15.6996H5.38739C5.47594 15.6996 5.55497 15.6442 5.58535 15.5611L8.95557 6.32189C8.98063 6.25315 8.92974 6.18042 8.85659 6.18042ZM10.4161 10.0517C10.3825 9.95937 10.2519 9.95937 10.2182 10.0517L9.55344 11.8742C9.53643 11.9208 9.53643 11.972 9.55344 12.0186L10.8456 15.561C10.876 15.6442 10.9551 15.6995 11.0436 15.6995H12.3258C12.3989 15.6995 12.4498 15.6268 12.4248 15.558L10.4161 10.0517ZM13.6848 11.8356C13.7184 11.9279 13.849 11.9279 13.8827 11.8356L15.8939 6.32189C15.919 6.25315 15.8681 6.18042 15.7949 6.18042H14.5127C14.4242 6.18042 14.3452 6.23572 14.3148 6.31895L13.02 9.86858C13.003 9.9152 13.003 9.9663 13.02 10.0129L13.6848 11.8356ZM11.1567 6.31797C11.1266 6.23537 11.0481 6.18042 10.9602 6.18042H9.6737C9.58522 6.18042 9.50619 6.23572 9.47581 6.31888L6.10566 15.5581C6.0806 15.6268 6.13149 15.6996 6.20464 15.6996H7.4869C7.57545 15.6996 7.65448 15.6443 7.68486 15.5611L10.2652 8.48706C10.2821 8.44065 10.3477 8.44065 10.3646 8.48706L12.945 15.5611C12.9753 15.6443 13.0544 15.6996 13.143 15.6996H14.4252C14.4984 15.6996 14.5493 15.6268 14.5242 15.5582L11.1567 6.31797ZM17.8944 6.18042H16.612C16.5236 6.18042 16.4445 6.23572 16.4141 6.31888L14.0696 12.7463C14.0526 12.7929 14.0526 12.844 14.0696 12.8906L14.7345 14.7133C14.7682 14.8056 14.8987 14.8056 14.9324 14.7133L17.2532 8.35077L17.9933 6.32182C18.0184 6.25315 17.9675 6.18042 17.8944 6.18042Z",
    fill: "#EF8220"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3452_13448",
    x1: 7.48649,
    y1: 3.7027,
    x2: 35.3243,
    y2: -11.4324,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B1B1B"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3452_13448"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 9.51916,
    fill: "white",
    transform: "translate(4 6.18042)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArbitrum);
export default __webpack_public_path__ + "static/media/arbitrum.3487d255884dfed263cdbe98351e0b71.svg";
export { ForwardRef as ReactComponent };